import IcSaveDocIcon from "@/assets/svg/ic_save_doc.svg?react";
import recordStore from "@/store/record.store";
import { useEffect } from "react";

let timer: NodeJS.Timeout;
export default function RecordTip() {
  const showSaveDocTip = recordStore((state) => state.showSaveDocTip);

  useEffect(() => {
    if (showSaveDocTip) {
      timer && clearTimeout(timer);
      timer = setTimeout(() => {
        recordStore.getState().setShowSaveDocTip(false);
      }, 10 * 1000);
    }
    return () => {
      timer && clearTimeout(timer);
    };
  }, [showSaveDocTip]);

  return (
    showSaveDocTip && (
      <div className="fixed text-3 text-mx-quaternary top-3 h-6 left-25 flex items-center">
        <IcSaveDocIcon className="size-4 mr-1" />
        已保存到云端
      </div>
    ) 
  );
}
